// frontend/src/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';
import { defaultHomePath, isPathAllowedForUser } from './accessPolicy';

const ProtectedRoute = ({ children, allowedGroups, allowStaff = false }) => {
    const { isAuthenticated, groups, isStaff } = useAuth();
    const location = useLocation();
    const safeGroups = Array.isArray(groups) ? groups : [];
    const auth = { isStaff, groups: safeGroups };

    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }

    if (!isPathAllowedForUser(location.pathname, auth)) {
        return <Navigate to={defaultHomePath(auth)} replace />;
    }

    const hasGroupAccess = allowedGroups?.length
        ? allowedGroups.some((g) => safeGroups.includes(g))
        : false;

    // Staff bypass when allowStaff is enabled
    if (allowStaff && isStaff) {
        return children;
    }

    // Group-based access (optionally combined with allowStaff for non-staff users)
    if (allowedGroups?.length) {
        return hasGroupAccess ? children : <Navigate to="/" replace />;
    }

    // allowStaff without allowedGroups = staff-only route
    if (allowStaff) {
        return <Navigate to="/" replace />;
    }

    // No restrictions — any authenticated user
    return children;
};

export default ProtectedRoute;
